const {LitElement, html, ref, createRef} = window.globalLit;
import BaseStepElement from './BaseStepElement.js';

customElements.define('click-step', class ClickStepElement extends BaseStepElement {

    selectorRef = createRef();

    render() {
        return html`
            <strong>Click on </strong>
            <element-selector 
                .value=${this.value.element}
                ?readonly=${this.readonly}
                @selectorchange="${this._onChange.bind(this, 'element')}">
            </element-selector>
        `;
    }
});